import { IPortabilityMobileCMS } from '@vfit/consumer/data-access';
import { purify } from '@vfit/shared/themes';

const getValidationByID = (editorialConfigs, id: string) => {
  const parser = new DOMParser();
  const value = editorialConfigs?.find((e) => e.id === id)?.value || '';
  const doc = parser.parseFromString(purify([value || ''])?.[0] || '', 'text/html');
  return doc?.body?.textContent?.replace('\n', '') || '';
};

export const evaluatePortabilityLabels = (labels: IPortabilityMobileCMS) => ({
  title: labels?.portabilitymobile?.migrationData?.title,
  description: labels?.portabilitymobile?.migrationData?.description,
  modalTitle: labels?.portabilitymobile?.migrationData?.modalTitle,
  modalDescription: labels?.portabilitymobile?.migrationData?.modalDescription,
  checkboxText: labels?.portabilitymobile?.migrationData?.checkboxText,
  operatorLabel: labels?.portabilitymobile?.selectInput?.operator,
  contractLabel: labels?.portabilitymobile?.selectInput?.contract,
  secondActionLabel: labels?.portabilitymobile?.migrationData?.actionLabel,
  preselectResidualCreditTransfer: labels?.portabilitymobile?.migrationData?.preselectResidualCreditTransfer === "true",
  validationMessage: {
    operator: {
      required:
        getValidationByID(labels?.editorialconfigs?.elements, 'operatorRequired') ||
        'Inserire un operatore',
    },
    contract: {
      required:
        getValidationByID(labels?.editorialconfigs?.elements, 'contractRequired') ||
        'Selezionare un contratto',
    },
  },
});
